import { render, staticRenderFns } from "./electric-rank.vue?vue&type=template&id=2e1e65dd&scoped=true"
import script from "./electric-rank.vue?vue&type=script&lang=js"
export * from "./electric-rank.vue?vue&type=script&lang=js"
import style0 from "./electric-rank.vue?vue&type=style&index=0&id=2e1e65dd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e1e65dd",
  null
  
)

export default component.exports